import React from 'react';
import { XIcon, ArrowRightIcon } from 'lucide-react';
import { problems } from '../data/comparison';
import { CtaButton } from './CtaButton';
export function Problems() {
  return <section className="w-full bg-bone py-20" aria-labelledby="problems-title" data-id="element-185" data-mp="324stci0y2tzi">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-186" data-mp="322oej51icakg">
        <h2 id="problems-title" className="font-display text-3xl font-black leading-tight tracking-tight text-court-950 sm:text-4xl" data-id="element-187" data-mp="2y2e7rq5w5g4j">
          Si entrenas tenis, seguramente estás lidiando con al menos uno de estos problemas:
        </h2>

        <ul className="mt-10 divide-y divide-court-950/10 border-y border-court-950/10" data-id="element-188" data-mp="2j5n8dgw7w4ex">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 py-4" data-id="element-189" data-mp="2f5wlvpdq4ag7">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-clay" strokeWidth={3} aria-hidden="true" data-id="element-190" data-mp="hfbrdwwd6di0" />
              <span className="text-base leading-relaxed text-court-800" data-id="element-191" data-mp="dbdu7rqlncrl">{problem}</span>
            </li>)}
        </ul>

        <p className="mt-12 font-display text-2xl font-extrabold tracking-tight text-court-950 sm:text-3xl" data-id="element-192" data-mp="39qhdkm3nhsp2">
          ¿Y si todo esto ya estuviera hecho para ti?
        </p>

        <div className="mt-8" data-id="element-193" data-mp="2zrs5tm5gxomj">
          <CtaButton href="#buy" variant="dark" className="w-full sm:w-auto" data-id="element-194" data-mp="2zr0a8bbvfqw9">
            Sí — muéstrame el sistema ya hecho
            <ArrowRightIcon className="ml-3 h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-195" data-mp="3nhw91seqvmd0" />
          </CtaButton>
          <p className="mt-3 text-xs text-court-600" data-id="element-196" data-mp="3sfnz0gvtwyek">
            Te lleva directo al paquete de $19 · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}